import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import useModalActions from "../../hooks/useModalActions";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import BaseButton from "../../components/BaseButton";

export default function UsingPrevGameAnswer({ onUsePrevGameAnswer }) {
  UsingPrevGameAnswer.propTypes = {
    onUsePrevGameAnswer: PropTypes.func,
  };
  const { t } = useTranslation();
  const { closeModal } = useModalActions();
  return (
    <BaseModal
      title={t("modals.using_prev_game_answer.title")}
      eventTypeModal={MODAL_TYPES.USING_PREV_GAME_ANSWER}
    >
      <BaseButton
        onClick={async () => {
          await onUsePrevGameAnswer();
          closeModal(MODAL_TYPES.USING_PREV_GAME_ANSWER);
        }}
      >
        {t("yes")}
      </BaseButton>
      <BaseButton
        unfilledWhite
        onClick={() => {
          closeModal(MODAL_TYPES.USING_PREV_GAME_ANSWER);
        }}
        className="modal-button-cancel"
      >
        {t("no")}
      </BaseButton>
    </BaseModal>
  );
}
